import { Outlet, Navigate } from 'react-router-dom'
import { getCookie } from '../utils/cookie'

const PrivateRoutes = () => {
  let auth = getCookie('authorization')
  return auth?.token ? <Outlet /> : <Navigate to="/login" />
}

export default PrivateRoutes
